import React, { useEffect } from 'react';
import { InputNumber, Form, DatePicker } from 'antd';


import locale from 'antd/es/date-picker/locale/ru_RU';

export default function NovieTarifTemplate(props) {
    const { object, form } = props;
    useEffect(() => {
        form.resetFields();
    }, []);

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item
                    label={"Окончание действия"}
                    name={"dataVremyaOkonchaniya"}
                    rules={[{ required: false, message: 'Пожалуйста, укажите окончание действия!' }]}
                >
                    <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                </Form.Item>
                <Form.Item
                    label={"Количество проданных до"}
                    name={"kolichestvoDo"}
                    rules={[{ required: false, message: 'Пожалуйста, укажите количество проданных до!' }]}
                >
                    <InputNumber min={1} />
                </Form.Item>
            </Form>
        </>
    );
}
